import React from "react";
import OPOnlineIframe from "../../../iframe-component/operation-online/OPOnIframe";
import usePageState from "utils/usePageState";

const OnlineMerchantDetailIframe = ({ path }) => {
  const { pageState } = usePageState({ pagePath: path });
  const merchantId = pageState.merchantId;

  // uses /merchant/list with merchantIdRedirect query parameter to redirect into merchant/info with the desired merchantId
  const urlPath = `/online-pay/merchant/merchant-list${merchantId ? "?merchantIdRedirect=" + merchantId : ""
    }`;

  return <OPOnlineIframe path={urlPath} />;
};

export default React.memo(OnlineMerchantDetailIframe);
